import React from 'react';

const Tag = ({ tag }) => {

    // rendering individual tag here
    return (
        <span>{tag}</span>
    );
};

export default Tag;